/* eslint-disable prefer-destructuring */
import PositionJdContent from 'components/_v2/positionJd/PositionJdContent';
import PositionJdKakaoComponent from 'components/_v2/positionJd/PositionJdKakaoComponent';
import PositionJdPosterSwiper from 'components/_v2/positionJd/PositionJdPosterSwiper';
import PositionJdPreviewCompanyInfo from 'components/_v2/preview/PositionJdPreviewCompanyInfo';
import PositionJdPreviewCompanyInfoTwo from 'components/_v2/preview/PositionJdPreviewCompanyInfoTwo';
import PositionJdPreviewWelfare from 'components/_v2/preview/PositionJdPreviewWelfare';
import IPositionJdProps from 'interfaces/_v2/positionJd/IPositionJdProps';
import { inject, observer } from 'mobx-react';
import PositionJdModel from 'models/_v2/PositionJdModel';
import { injectStore } from 'models/store';
import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { iframePinchZoomUtil } from 'utils/_v2/iframePinchZoomUtils';
import KakaoMapScript from 'utils/_v2/kakaoMap/KakaoMapScript';
import { IsJsonString } from 'utils/_v2/validation';
import AutoHeightIFrame from './AutoHeightIframe';

const Frame = styled.div<{ notExternalYn: boolean }>`
    overflow: hidden; // swiper를 위한 overflow
    pointer-events: none; 
    padding : 0 0 72px 0;

    .frame-top{
      padding : 10px 16px 32px 16px;
    }

    ${(props) => !props.notExternalYn
      && css`
        padding-bottom: 24px;

        .frame-top {
          padding-bottom: 0;
        }
    `};
`;

const PositionJdPreview:FC<IPositionJdProps> = ({ positionJdModel = new PositionJdModel() }) => {
  const { search } = useLocation();
  const [positionDetail, setPositionDetail] = useState<any>(null);
  // const { data } = CommonUtils.parseQuery(search);
  const { kakao } = window;

  const getLocation = async (address:string) => {
    await positionJdModel.getLocationPreview(address);
    KakaoMapScript(positionJdModel.locationX, positionJdModel.locationY, address);
  };
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      const data = event.data;
      try {
        const parsedData = JSON.parse(data);
        setPositionDetail(parsedData);

        if (parsedData?.basicInfo?.address) {
          if (kakao) {
            getLocation(parsedData.basicInfo.address);
          }
        }
      } catch (error) {
        console.error('Failed to parse data:', error);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [kakao]);

  return (
    <Frame notExternalYn>
      {
        positionDetail && (
          <>
            <div className='frame-top'>
              <PositionJdPreviewCompanyInfo basicInfo={positionDetail.basicInfo} companyInfo={positionDetail.companyInfo} additionalInfo={positionDetail.additionalInfo} />
            </div>
            <PositionJdPosterSwiper />
            <div className='frame-top'>
              {
  positionDetail.companyInfo && <PositionJdPreviewCompanyInfoTwo companyInfo={positionDetail.companyInfo} />
}

            </div>
            {positionDetail.basicInfo
        && positionDetail.basicInfo.jobDescription && IsJsonString(positionDetail.basicInfo.jobDescription)
              ? <PositionJdContent value={JSON.parse(positionDetail.basicInfo.jobDescription)} />
              : <AutoHeightIFrame srcDoc={iframePinchZoomUtil(positionDetail.basicInfo.jobDescription)} />}
            { positionDetail.basicInfo?.address && <PositionJdKakaoComponent />}
            { positionDetail.additionalInfo && positionDetail.additionalInfo?.welfareKeywords.length !== 0
      && <PositionJdPreviewWelfare additionalInfo={positionDetail.additionalInfo} />}

          </>
        )
      }

    </Frame>
  );
};
export default inject(injectStore.positionJdModel)(observer(PositionJdPreview));
// console.log(JSON.stringify(data));

/*

{"basicInfo":{"positionName":"용구랑 종완 포지션","recruitmentType":"NEW","address":"경기 성남시 분당구 판교동","minSalary":2000,"maxSalary":12000,"openingDateTime":"2022-07-11T10:55:55","closingDateTime":null,"jobDescription":"[{\"type\":\"title\",\"children\":[{\"text\":\"회사소개\"}]},{\"type\":\"paragraph\",\"children\":[{\"text\":\"회사 소개를 입력해 주세요\"}]},{\"type\":\"title\",\"children\":[{\"text\":\"주요업무\"}]},{\"type\":\"bulleted-list\",\"children\":[{\"type\":\"list-item\",\"children\":[{\"text\":\"주요 업무를 입력해 주세요\"}]}]},{\"type\":\"title\",\"children\":[{\"text\":\"이런 인재를 찾아요!\"}]},{\"type\":\"paragraph\",\"children\":[{\"text\":\"이런 지식/기술/경험을 지니신 분을 찾아요.\"}]},{\"type\":\"bulleted-list\",\"children\":[{\"type\":\"list-item\",\"children\":[{\"text\":\"\"}]}],\"label\":\"preferential-condition-list\"},{\"type\":\"paragraph\",\"children\":[{\"text\":\"이런 역량을 지니신 분을 찾아요.\"}]},{\"type\":\"bulleted-list\",\"children\":[{\"type\":\"list-item\",\"children\":[{\"text\":\"\"}]}],\"label\":\"competency-keyword-list\"},{\"type\":\"paragraph\",\"children\":[{\"text\":\"\\n채용인원 : 최대 1명\"}],\"label\":\"number-of-employees\"},{\"type\":\"title\",\"children\":[{\"text\":\"영입절차\"}]},{\"type\":\"paragraph\",\"children\":[{\"text\":\"ATS Dev Space으로의 합류여정입니다.\"}]},{\"type\":\"bulleted-list\",\"children\":[{\"type\":\"list-item\",\"children\":[{\"text\":\"지원하기 > 직무인터뷰 > 최종합격\"}]}]}]","images":[{"fileUrl":"https://static-jobda-im.kr-dv-jainwon.com/public/a6b08f6c-06c4-4a03-a817-c2f10e629112.png","caption":"용구랑 종완"},{"fileUrl":"https://static-jobda-im.kr-dv-jainwon.com/public/7c7f702f-0faa-4c28-a189-e04762a6230f.png","caption":"용구랑 종완"},{"fileUrl":"https://static-jobda-im.kr-dv-jainwon.com/public/e34df2df-305b-40d0-b97a-b3ab1c3494a1.png","caption":"용구랑 종완"}]},"additionalInfo":{"locationCode":10009,"jobTitleNames":["회계 · 재무 · 세무"],"welfareKeywords":["사내 병원","자유로운 연차"],"welfareWithCategories":[{"name":"건강 지원","welfares":["사내 병원"]},{"name":"휴가제도","welfares":["자유로운 연차"]}]},"companyInfo":{"companyName":"(주)유레카엔터프라이즈","ceoName":"한장현","startingSalary":110000,"averageSalary":220000,"numberOfEmployees":null,"businessSize":"SMALL","establishDate":"2019-11-13","location":"경기 성남시 수정구 시흥동 288-11","revenue":4121240000,"openYn":true,"logoImageUrl":"https://static-jobda-im.kr-dv-jainwon.com/public/6d0d7ff6-3079-4c18-bd29-89ac152a15cb.png","lastModifiedDate":"2024-05-29"}}

*/

const datas = {
  basicInfo: {
    positionName: '용구랑 종완 포지션',

    recruitmentType: 'NEW',

    address: '경기 성남시 분당구 판교동',

    minSalary: 2000,

    maxSalary: 12000,

    openingDateTime: '2022-07-11T10:55:55',

    closingDateTime: null,

    jobDescription:
      '[{"type":"title","children":[{"text":"회사소개"}]},{"type":"paragraph","children":[{"text":"회사 소개를 입력해 주세요"}]},{"type":"title","children":[{"text":"주요업무"}]},{"type":"bulleted-list","children":[{"type":"list-item","children":[{"text":"주요 업무를 입력해 주세요"}]}]},{"type":"title","children":[{"text":"이런 인재를 찾아요!"}]},{"type":"paragraph","children":[{"text":"이런 지식/기술/경험을 지니신 분을 찾아요."}]},{"type":"bulleted-list","children":[{"type":"list-item","children":[{"text":""}]}],"label":"preferential-condition-list"},{"type":"paragraph","children":[{"text":"이런 역량을 지니신 분을 찾아요."}]},{"type":"bulleted-list","children":[{"type":"list-item","children":[{"text":""}]}],"label":"competency-keyword-list"},{"type":"paragraph","children":[{"text":"\\n채용인원 : 최대 1명"}],"label":"number-of-employees"},{"type":"title","children":[{"text":"영입절차"}]},{"type":"paragraph","children":[{"text":"ATS Dev Space으로의 합류여정입니다."}]},{"type":"bulleted-list","children":[{"type":"list-item","children":[{"text":"지원하기 > 직무인터뷰 > 최종합격"}]}]}]',

    images: [
      {
        fileUrl: 'https://static-jobda-im.kr-dv-jainwon.com/public/a6b08f6c-06c4-4a03-a817-c2f10e629112.png',

        caption: '용구랑 종완',
      },

      {
        fileUrl: 'https://static-jobda-im.kr-dv-jainwon.com/public/7c7f702f-0faa-4c28-a189-e04762a6230f.png',

        caption: '용구랑 종완',
      },

      {
        fileUrl: 'https://static-jobda-im.kr-dv-jainwon.com/public/e34df2df-305b-40d0-b97a-b3ab1c3494a1.png',

        caption: '용구랑 종완',
      },
    ],
  },

  additionalInfo: {
    locationCode: 10009,
    jobTitleNames: ['회계 · 재무 · 세무'],

    welfareKeywords: ['사내 병원', '자유로운 연차'],

    welfareWithCategories: [
      {
        name: '건강 지원',

        welfares: ['사내 병원'],
      },

      {
        name: '휴가제도',

        welfares: ['자유로운 연차'],
      },
    ],
  },

  companyInfo: {
    companyName: '(주)유레카엔터프라이즈',

    ceoName: '한장현',

    startingSalary: 110000.0,

    averageSalary: 220000.0,

    numberOfEmployees: null,

    businessSize: 'SMALL',

    establishDate: '2019-11-13',

    location: '경기 성남시 수정구 시흥동 288-11',

    revenue: 4121240000.0,
    openYn: true,
    logoImageUrl: 'https://static-jobda-im.kr-dv-jainwon.com/public/6d0d7ff6-3079-4c18-bd29-89ac152a15cb.png',
    lastModifiedDate: '2024-05-29',
  },
};
